import { EVENT_LABELS } from './analytics.constants'
export const buildLabelObject = (
    name: string,
    placement: string,
    links: number,
    position?: number,
    url?: string,
): string => {
    return `${EVENT_LABELS.NAME}=[${name}];${EVENT_LABELS.PLACEMENT}=[${placement}];${EVENT_LABELS.LINKS}=[${links}];${
        position ? ` ${EVENT_LABELS.POSITION}=[${position}];` : ''
    }${url ? `${EVENT_LABELS.URL}=[${url}]` : ''}`
}
